var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"2.41421","y1":"1.58579","x2":"18.4142","y2":"17.5858","stroke":"white","strokeWidth":"4","key":0}),React.createElement("line",{"x1":"2.25376","y1":"17.5858","x2":"18.2538","y2":"1.58579","stroke":"white","strokeWidth":"4","key":1})]);
}

CloseInline.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 19","fill":"none","className":"icon"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
